import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIG_OFFER_PRICE_EUR } from '../config/configurationOffer';
import './ConfigurationOfferSection.css';

interface ConfigurationOfferSectionProps {
    onCTAClick: () => void;
}

const FEATURE_KEYS = [
    'profile',
    'services',
    'planning',
    'payments',
    'bookingPage',
    'autoMessages',
    'clientImport',
] as const;

const ConfigurationOfferSection: React.FC<ConfigurationOfferSectionProps> = ({ onCTAClick }) => {
    const { t } = useTranslation('marketing');
    const ns = 'configurationOfferSection';

    return (
        <section id="pret-a-servir" className="ready-to-serve-section config-theme">
            <div className="ready-to-serve-container">
                <div className="ready-to-serve-badge config-badge">{t(`${ns}.badge`)}</div>
                <h2 className="ready-to-serve-title">{t(`${ns}.title`)}</h2>
                <div className="ready-to-serve-price">
                    <span className="price-amount">{CONFIG_OFFER_PRICE_EUR}€</span>
                    <span className="price-once">{t(`${ns}.priceOnce`)}</span>
                </div>

                <p className="ready-to-serve-pricing-note">{t(`${ns}.subscriptionDisclaimer`)}</p>

                <p className="ready-to-serve-intro">{t(`${ns}.intro`)}</p>

                <div className="ready-to-serve-features">
                    {FEATURE_KEYS.map((key) => (
                        <div key={key} className="feature-item">
                            <span className="feature-check">✓</span>
                            <span>{t(`${ns}.features.${key}`)}</span>
                        </div>
                    ))}
                    <div className="feature-item">
                        <span className="feature-check">🎁</span>
                        <span>
                            <strong>{t(`${ns}.features.premiumWeek`)}</strong>
                        </span>
                    </div>
                </div>

                <div className="ready-to-serve-bonus">
                    <div className="bonus-icon">🎥</div>
                    <div className="bonus-text">
                        <strong>{t(`${ns}.bonusTitle`)}</strong>
                        <p>{t(`${ns}.bonusDescription`)}</p>
                    </div>
                </div>

                <a
                    href="https://buy.stripe.com/9B69AU2Pv9DfamP91qew805"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ready-to-serve-cta config-cta"
                    onClick={onCTAClick}
                >
                    {t(`${ns}.cta`)}
                </a>

                <p className="ready-to-serve-subtext">{t(`${ns}.subtext`)}</p>
            </div>
        </section>
    );
};

export default ConfigurationOfferSection;
